export const ExportTypes = {
  klic: 'klic',
  risicogrid: 'risicogrid',
  veiliggraven: 'veiliggraven',
} as const;

export type ExportTypes = (typeof ExportTypes)[keyof typeof ExportTypes];

export const FMEDownloadTypes = {
  shapefile: 'shapefile',
  dwg: 'dwg',
  geopackage: 'geopackage',
  geodatabase: 'geodatabase',
  dxf: 'dxf',
  excel: 'excel',
  kml: 'kml',
} as const;

export type FMEDownloadTypes = (typeof FMEDownloadTypes)[keyof typeof FMEDownloadTypes];

export const ExportConfigurations = [
  {
    name: 'nlcs',
    alias: 'NLCS',
    description:
      'Lagen volgens de NLCS (Nederlandse CAD Standaard). Kabels en leidingen worden ingedeeld en gesymboliseerd volgens de landelijke CAD-standaard, ideaal voor verdere verwerking in CAD-tekeningen.',
  },
  {
    name: 'objecttype',
    alias: 'Objecttype',
    description:
      'Eén laag per IMKL-objecttype, zoals kabels, leidingen, mantelbuizen, kasten en annotaties. Handig als je wilt werken met specifieke soorten objecten, ongeacht thema of netbeheerder.',
  },
  {
    name: 'thema',
    alias: 'Thema',
    description:
      'Eén laag per thema, zoals laagspanning, gas lage druk, water of datatransport. Zo zie je in één oogopslag welke soorten netten in het gebied liggen.',
  },
  {
    name: 'netbeheerder',
    alias: 'Netbeheerder',
    description:
      'Eén laag per netbeheerder. Handig om per netbeheerder te controleren welke kabels en leidingen zij hebben aangeleverd.',
  },
  {
    name: 'objecttype_thema',
    alias: 'Objecttype + Thema',
    description:
      'Lagen per combinatie van objecttype en thema, bijvoorbeeld "Kabel – laagspanning" of "Leiding – gas lage druk".',
  },
  {
    name: 'objecttype_netbeheerder',
    alias: 'Objecttype + Netbeheerder',
    description:
      'Lagen per combinatie van objecttype en netbeheerder, bijvoorbeeld alle leidingen van één specifieke netbeheerder.',
  },
  {
    name: 'netbeheerder_thema',
    alias: 'Netbeheerder + Thema',
    description:
      'Lagen per combinatie van netbeheerder en thema, bijvoorbeeld de laagspanningskabels van één specifieke netbeheerder.',
  },
  {
    name: 'objecttype_thema_netbeheerder',
    alias: 'Objecttype + Thema + Netbeheerder',
    description:
      'De meest gedetailleerde indeling: lagen per combinatie van objecttype, thema en netbeheerder. Levert veel lagen op, maar geeft maximale controle.',
  },
  {
    name: 'standaard',
    alias: 'Standaard',
    description:
      'Een vaste, eenvoudige indeling met de volgende lagen:<ul><li>Puntobjecten</li><li>Lijnen</li><li>Aanvraaggebieden</li><li>Eis voorzorgsmaatregelen</li><li>Bijlage-vlakken</li><li>Bijlage-lijnen</li><li>Bijlage-punten</li><li>Extra geometrieën</li></ul>Elk object bevat daarbij zijn eigenschappen, zoals objecttype, thema en netbeheerder, als attributen.',
  },
] as const;

export type ExportConfiguration = (typeof ExportConfigurations)[number]['name'];
